import { isChunkLoadError } from '../../lib/chunk-reload';
import { EmptyState } from './common';

/** Router `defaultErrorComponent`: a Hebrew screen instead of the library's English dump. */
export function RouteError(props: { error: unknown; reset?: () => void }) {
  const chunk = isChunkLoadError(props.error);
  return (
    <div className="content">
      <EmptyState
        icon="alert"
        title={chunk ? 'יצאה גרסה חדשה של האתר' : 'משהו השתבש בטעינת המסך'}
        text={chunk ? 'צריך לרענן כדי לטעון אותה.' : 'אפשר לרענן את הדף. אם זה חוזר, נסו שוב בעוד דקה.'}
        action={
          <div className="row" style={{ justifyContent: 'center', gap: 8, marginTop: 12 }}>
            <button type="button" className="btn primary" onClick={() => window.location.reload()}>
              רענון
            </button>
            <a className="btn" href="/">
              חזרה לבית
            </a>
          </div>
        }
      />
    </div>
  );
}
